module.exports = __webpack_public_path__ + "img/xindrb.267c63f0.svg";